let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Utwg")).then(() => parcelRequire('4TzQ2'));